import React, { Component } from 'react';
import kominfoTeam1 from '../../assets/kominfo-team-1.png';

export default class Obligation extends Component {
  render() {
    return (
      <section id="kewajiban-psre-induk">
        <p style={{fontSize: '18px', color: "#0085C7",fontWeight: '600', marginBottom: '25px'}}>9 Kewajiban PSrE Induk</p>
        <img src={kominfoTeam1} alt="kominfo-team-3" style={{width: '100%', height: 'auto', marginBottom: '15px'}}/>
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 col-12" >
            <div className="d-flex mb-3">
              <div className="rect-blue">1</div>
              <p style={{fontSize: '13px'}}>Menyelenggarakan Administrasi<br/> bagi Pemohon</p>
            </div>
            <div className="d-flex mb-3">
              <div className="rect-blue">2</div>
              <p style={{fontSize: '13px'}}>Melakukan Verifikasi Kebenaran <br/> identitas Pemohon</p>
            </div>
            <div className="d-flex mb-3">
              <div className="rect-blue">3</div>
              <p style={{fontSize: '13px'}}>Memastikan masa berlaku Sertifikat <br/> Elektronik</p>
            </div>
            <div className="d-flex mb-3">
              <div className="rect-blue">4</div>
              <p style={{fontSize: '13px'}}>Melakukan Perpanjangan masa <br/>berlaku bagi pemilik yang meminta.</p>
            </div>
            <div className="d-flex mb-3">
              <div className="rect-blue">5</div>
              <p style={{fontSize: '13px'}}>Membuat basis data Sertifikat aktif dan<br/>non-aktif, paper based, dan electronic based</p>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <div className="d-flex mb-3">
              <div className="rect-blue">6</div>
              <p style={{fontSize: '13px'}}>Menempatkan dan mempublikasikan<br/> Sertifikat Elektronik dalam Repository</p>
            </div>
            <div className="d-flex mb-3">
              <div className="rect-blue">7</div>
              <p style={{fontSize: '13px'}}>Menjaga kerahasiaan identitas pemilik<br/> sertifikat elektronik</p>
            </div>
            <div className="d-flex mb-3">
              <div className="rect-blue">8</div>
              <p style={{fontSize: '13px'}}>Memberitahukan CP/CPS (Certificate<br/> Policy serta Certification Practice Statement)</p>
            </div>
            <div className="d-flex mb-3">
              <div className="rect-blue">9</div>
              <p style={{fontSize: '13px'}}>Membuat laporan operasional periodik /<br/> sewaku-waktu kepada Menteri Kominfo</p>
            </div>
          </div>
        </div>
      </section>
    )
  }
}
